import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { Table, Breadcrumb } from 'react-bootstrap';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { FaDownload, FaEye } from 'react-icons/fa';

import DocumentationService from 'Services/DocumentationService';
import { getMediaUrl } from 'Utils/Helpers';

const Documentations = () => {
    const [documentations, setDocumentations] = useState([]);

    useEffect(() => {
        DocumentationService.getDocumentations()
            .then((result) => {
                if (result.status === 200) {
                    setDocumentations(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    Home
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
                    Admin
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Documentations</Breadcrumb.Item>
            </Breadcrumb>
            <div className="d-flex justify-content-between align-items-center py-2">
                <h2>Documentations</h2>
                <Link to="/admin/documentation/create">
                    <button className="btn btn-outline-primary btn-sm">
                        <AiOutlinePlusCircle></AiOutlinePlusCircle>
                        <span className="ml-1">New</span>
                    </button>
                </Link>
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Fichier</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {documentations.length ? (
                        documentations.map((documentations, key) => {
                            return (
                                <tr key={key}>
                                    <td>{documentations.name}</td>
                                    <td>
                                        {documentations.fileUrl ? (
                                            <>
                                                <a
                                                    href={getMediaUrl(documentations.fileUrl)}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="btn btn-sm btn-outline-secondary me-1"
                                                    title="Voir"
                                                >
                                                    <FaEye />
                                                </a>
                                                <a
                                                    href={getMediaUrl(documentations.fileUrl)}
                                                    download
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="btn btn-sm btn-outline-primary"
                                                    title="Télécharger"
                                                >
                                                    <FaDownload />
                                                </a>
                                            </>
                                        ) : (
                                            <span className="text-muted">—</span>
                                        )}
                                    </td>
                                    <td>
                                        <Link to={`/admin/documentation/edit/${documentations.documentationId}`}>
                                            <img
                                                src="/images/edit.svg"
                                                alt=""
                                                style={{
                                                    height: '15pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to={`/admin/documentation/delete/${documentations.documentationId}`}>
                                            <img
                                                src="/images/delete.svg"
                                                alt=""
                                                style={{
                                                    height: '18pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4">no data</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
};

export default Documentations;
